"use client";
import { Button } from "@base-ui/react/button";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useCallback } from "react";
import { cn } from "@/lib/utils";

const genderList = [
  { id: 2, title: "Erkek" },
  { id: 1, title: "Kız" },
];

const Genders = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const activeGender = searchParams.get("Gender");

  const createQueryString = useCallback(
    (name: string, value: string) => {
      const params = new URLSearchParams(searchParams.toString());
      params.set(name, value);

      return params.toString();
    },
    [searchParams],
  );
  return (
    <>
      {genderList.map((gender) => (
        <Button
          className={cn(
            "rounded-full w-fit shrink-0 border border-neutral-200 text-neutral-800 px-4 py-2 font-medium hover:bg-brand-blue-100 hover:border-brand-blue-500 transition-colors",
            {
              "border-brand-blue-600 bg-brand-blue-600 text-white hover:bg-brand-blue-600":
                gender.id === Number(activeGender),
            },
          )}
          key={gender.id}
          onClick={() =>
            router.push(
              `${pathname}?${createQueryString("Gender", gender.id.toString())}`,
            )
          }
        >
          {gender.title}
        </Button>
      ))}
    </>
  );
};

export default Genders;
